/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(document).on('click', ".ais-current-refined-values--item", function () {
  const item = $(this).find("div[data-item]");
  if (item.length) {
    return $('#' + $(item).data('item')).datepicker('setDate', null);
  }
});

window.WorkplaceUtils = {
  assignRefineData(item) {
    return Object.keys(item).map(key => `data-${key}='${item[key]}'`).join(' ');
  },

  currentRefinedTemplate(filter) {
    let attributeName = filter.attribute || filter.type;
    attributeName = WorkplaceUtils.formattedAttributeName(attributeName);

    return this._renderSingleRefinement(filter, attributeName);
  },

  _renderSingleRefinement(filter, attributeName) {
    if (attributeName.match(/_at$/) || attributeName.includes('valid_') || attributeName.includes('date_int')) {
      return this._renderDateRefinement(filter, attributeName);
    } else if (attributeName.includes('budget')) {
      return this._renderBudgetRefinement(filter, attributeName);
    } else if (attributeName.split('.').includes('categories')) {
      return this._renderCategoryRefinement(filter);
    } else if (attributeName == 'company_activities') {
      return this._renderCompanyActivityRefinement(filter, attributeName);
    } else {
      attributeName = attributeName.replace(/_/g, ' ');
      return this._renderDefaultRefinement(filter, attributeName);
    }
  },

  _renderCategoryRefinement(filter) {
    return `<div class='ais-CurrentRefinements-item'>
      ${this._itemWrapper(filter.refinements[0], filter.refinements[0].value)}
      </div>`;
  },

  _renderCompanyActivityRefinement(filter, attributeName) {
    // 123_piling_contractor => Piling Contractor
    count = `<span class='ais-CurrentRefined-count'>${filter.refinements[0].count}</span>`
    value = filter.refinements[0].value.split('_').slice(1).join(' ')

    return `<div class='ais-CurrentRefinements-item'>
      <span>${attributeName.replace(/_/g, ' ')}: </span>
      ${this._itemWrapper(filter.refinements[0], `${value} (${count})`)}        
      </div>`;
  },

  _renderDateRefinement(filter, attributeName) {
    attributeName = attributeName.split('_')[0];
    const singleItem = item => {
      const operatorLabel = item.operator === ">=" ? "from" : "to";

      return this._itemWrapper(item, `${operatorLabel} ${moment.unix(item.value).format('MMM DD, YYYY')}`);
    };

    return `<div class='ais-CurrentRefinements-item'>
      <span>${WorkplaceUtils.capitalize(attributeName)}:</span>
        ${_.map(filter.refinements, singleItem).join('')}
      </div>`;
  },

  _renderBudgetRefinement(filter) {
    const items = filter.refinements.sort((a, b) => b.operator - a.operator);
    return `<div class='ais-CurrentRefinements-item'>
  <span>Budget ($M):</span>
  ${_.map(items, item => this._itemWrapper(item, item.label)).join('')}
</div>`;
  },

  _renderDefaultRefinement(filter, attributeName, count) {
    const singleItem = item => {
      count = ((item.count === undefined) || (item.count === 0)) ? '' : `<span class='ais-CurrentRefined-count'>${item.count}</span>`;
      const text = (attributeName === 'status') ? I18n.t(`enumerize.project.status.${item.value}`) : item.value;
      const value = count === '' ?
        text
        :
        `${text} (${count})`;

      return this._itemWrapper(item, value);
    };

    return `<div class='ais-CurrentRefinements-item'>
  <span>${WorkplaceUtils.capitalize(attributeName)}:</span>
  ${_.map(filter.refinements, singleItem).join('')}
</div>`;
  },

  _itemWrapper(item, content) {
    return `<a class='ais-CurrentRefinements-link' ${WorkplaceUtils.assignRefineData(item)}>
        ${content}
      </a>`;
  },

  formattedAttributeName(attrName) {
    if (attrName.includes('.') && !attrName.includes('categories')) {
      const splittedName = attrName.split('.');
      if (splittedName[0] === 'user_tags') {
        return 'Tag';
      } else if (splittedName[1] === 'formatted') {
        return splittedName[0];
      } else {
        return splittedName[1];
      }
    } else if (attrName.match(/_formatted_status$/)) {
      return attrName.split('_formatted_status')[0];
    } else {
      return attrName;
    }
  },

  compareNodeStrings(valueA, valueB, nodeA, nodeB, name) {
    const v1 = nodeA.data[name];
    const v2 = nodeB.data[name];
    return this._compareStrings(v1, v2);
  },

  _compareStrings(v1, v2) {
    if (!v1 && !v2) { return 0; }
    if (!v1) { return -1; }
    if (!v2) { return 1; }
    return v1.localeCompare(v2);
  },

  compareNodeNumbers(valueA, valueB, nodeA, nodeB, name) {
    const v1 = nodeA.data[name];
    const v2 = nodeB.data[name];
    return this._compareNumbers(v1, v2);
  },

  compareNodeLength(valueA, valueB, nodeA, nodeB, name) {
    const v1 = nodeA.data[name].length;
    const v2 = nodeB.data[name].length;
    return this._compareNumbers(v1, v2);
  },

  _compareNumbers(v1, v2) {
    if (!v1 && !v2) { return 0; }
    if (!v1) { return -1; }
    if (!v2) { return 1; }
    return v1 - v2;
  },

  capitalizeAllWords(str) {
    let arr = str.split(/[ ]/);
    str = _.reduce(arr, (mem, val) => {
      return [mem, this.capitalize(val)].join(' ');
    });

    arr = str.split(/[-]/);
    return _.reduce(arr, (mem, val) => {
      return [mem, this.capitalize(val)].join('-');
    });
  },

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },

  dasherize(str) {
    return str.replace(/[-_\s]+/g, '-').toLowerCase();
  },

  switchView(event) {
    const url = new URL(document.URL);
    const view = $(event.target).closest('a').data('view');
    if (view === 'table') {
      url.searchParams.set('view', view);
    } else {
      url.searchParams.delete('view');
    }
    return window.location = url.href;
  }
};
